import { JobStatuses } from "@legacy/core/utils/enums"

import useHasAccess from "@hooks/useHasAccess"

import { Table } from "@organisms"

import { JOBS_ROUTES } from "@routes/jobs"

export const JobTableViewTabs = () => {
    const { hasFlag } = useHasAccess()

    return (
        <Table.Tabs>
            <Table.Tab
                id="all_open"
                phase="open"
                title="All Open"
                isDefaultActiveTabForPhase={true}
                endpointKwargs={[
                    ["status", JobStatuses.pending],
                    ["status", JobStatuses.scheduled],
                    ["status", JobStatuses.active],
                    ["status", JobStatuses.paused],
                    ["status", JobStatuses.on_hold],
                    ["status", JobStatuses.completed],
                    ["is_archived", "false"],
                    ["ordering", "start_time"],
                ]}
                listEndpoint={JOBS_ROUTES.LIGHTWEIGHT_LIST}
                countEndpoint={JOBS_ROUTES.COUNT}
            />
            <Table.Tab
                title="Pending"
                phase="open"
                endpointKwargs={[
                    ["status", JobStatuses.pending],
                    ["is_archived", "false"],
                    ["ordering", "-id"],
                ]}
                id="pending"
                hide={hasFlag("restricted_to_assigned_jobs")}
                listEndpoint={JOBS_ROUTES.LIGHTWEIGHT_LIST}
                countEndpoint={JOBS_ROUTES.COUNT}
            />
            <Table.Tab
                id="scheduled"
                title="Scheduled"
                phase="open"
                endpointKwargs={[
                    ["status", JobStatuses.scheduled],
                    ["is_archived", "false"],
                    ["ordering", "start_time"],
                ]}
                listEndpoint={JOBS_ROUTES.LIGHTWEIGHT_LIST}
                countEndpoint={JOBS_ROUTES.COUNT}
            />
            <Table.Tab
                id="in_progress"
                title="In Progress"
                phase="open"
                endpointKwargs={[
                    ["status", JobStatuses.active],
                    ["status", JobStatuses.paused],
                    ["is_archived", "false"],
                    ["ordering", "start_time"],
                ]}
                listEndpoint={JOBS_ROUTES.LIGHTWEIGHT_LIST}
                countEndpoint={JOBS_ROUTES.COUNT}
            />
            <Table.Tab
                id="on_hold"
                title="On Hold"
                phase="open"
                endpointKwargs={[
                    ["status", JobStatuses.on_hold],
                    ["is_archived", "false"],
                    ["ordering", "start_time"],
                ]}
                listEndpoint={JOBS_ROUTES.LIGHTWEIGHT_LIST}
                countEndpoint={JOBS_ROUTES.COUNT}
            />
            <Table.Tab
                id="completed"
                title="Completed"
                phase="open"
                endpointKwargs={[
                    ["status", JobStatuses.completed],
                    ["is_archived", "false"],
                    ["ordering", "-last_completed_at"],
                ]}
                listEndpoint={JOBS_ROUTES.LIGHTWEIGHT_LIST}
                countEndpoint={JOBS_ROUTES.COUNT}
            />
            <Table.Tab
                id="all_closed"
                title="All Closed"
                phase="closed"
                isDefaultActiveTabForPhase={true}
                endpointKwargs={[
                    ["status", JobStatuses.finalized],
                    ["status", JobStatuses.cancelled],
                    ["is_archived", "true"],
                    ["ordering", "-id"],
                ]}
                listEndpoint={JOBS_ROUTES.LIGHTWEIGHT_LIST}
                countEndpoint={JOBS_ROUTES.COUNT}
            />
            <Table.Tab
                id="finalized"
                title="Finalized"
                phase="closed"
                endpointKwargs={[
                    ["status", JobStatuses.finalized],
                    ["is_archived", "true"],
                    ["ordering", "-last_finalized_at"],
                ]}
                listEndpoint={JOBS_ROUTES.LIGHTWEIGHT_LIST}
                countEndpoint={JOBS_ROUTES.COUNT}
            />
            <Table.Tab
                id="cancelled"
                title="Cancelled"
                phase="closed"
                endpointKwargs={[
                    ["status", JobStatuses.cancelled],
                    ["is_archived", "true"],
                    ["ordering", "-start_time"],
                ]}
                listEndpoint={JOBS_ROUTES.LIGHTWEIGHT_LIST}
                countEndpoint={JOBS_ROUTES.COUNT}
            />
        </Table.Tabs>
    )
}
